import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-charcoal text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-2xl font-semibold">Lalita</span>
              <span className="font-heading text-2xl font-normal text-white/60 ml-1">Properties</span>
            </Link>
            <p className="text-white/70 font-body text-sm leading-relaxed mb-6">
              Bali&apos;s boutique property management and real estate brokerage. Helping villa owners buy, rent, and manage properties with trusted local expertise.
            </p>
            <div className="flex space-x-4">
              <a href="https://instagram.com/lalitaproperties" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 hover:from-purple-700 hover:via-pink-600 hover:to-orange-500 transition-all shadow-lg" aria-label="Instagram">
                <Instagram className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-medium mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { href: '/properties', label: 'Browse Properties' },
                { href: '/regions', label: 'Browse by Region' },
                { href: '/property-management', label: 'Property Management' },
                { href: '/real-estate', label: 'Real Estate Services' },
                { href: '/blog', label: 'Blog' },
                { href: '/about', label: 'About Us' },
                { href: '/contact', label: 'Contact' },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/70 hover:text-white transition-colors font-body text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-medium mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-ubud-jungle mt-0.5 flex-shrink-0" />
                <span className="text-white/70 font-body text-sm">
                  Jalan Umalas Tunon<br />
                  Kerobokan Kelod, Kuta Utara<br />
                  Badung, Bali 80361
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-ubud-jungle flex-shrink-0" />
                <a href="tel:+628778442377" className="text-white/70 hover:text-white font-body text-sm">
                  +62 877 8442 3377
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-ubud-jungle flex-shrink-0" />
                <a href="mailto:hello@lalita.id" className="text-white/70 hover:text-white font-body text-sm">
                  hello@lalita.id
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 font-body text-sm">
            &copy; {new Date().getFullYear()} Lalita Properties. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-white/50 hover:text-white font-body text-sm">Privacy Policy</a>
            <a href="#" className="text-white/50 hover:text-white font-body text-sm">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
